window.theme = window.theme || {};
window.theme.calcTimeAgo = window.theme.calcTimeAgo || function(time) {
  var diff = Date.now() - time;
  var seconds = Math.floor(diff / 1000);
  if (seconds < 60) return "Just now";
  var minutes = Math.floor(seconds / 60);
  if (minutes < 60) return minutes + " minutes ago";
  var hours = Math.floor(minutes / 60);
  if (hours < 24) return hours + " hours ago";
  var days = Math.floor(hours / 24);
  return days + " days ago";
};
window.Shopify = window.Shopify || {};
window.Shopify.formatMoney = window.Shopify.formatMoney || function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || window.Shopify.moneyFormat || '${{amount}}');

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  var match = formatString.match(placeholderRegex);
  if (!match) {
    return formatWithDelimiters(cents, 2);
  }

  switch(match[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
class Wishlist extends HTMLElement {
  constructor () {
    super()

    this.setCountBadges()
    this.setContent()
  }

  get wishlist () {
    return JSON.parse(localStorage.getItem('ks-wishlist')) || []
  }

  set wishlist (array) {
    localStorage.setItem('ks-wishlist', JSON.stringify(array))
  }

  async setProduct (url) {
    let wishlist = this.wishlist
    const isWishlisted = this.wishlist.some((elem) => elem.url === url)

    if (isWishlisted) {
      wishlist = this.wishlist.filter((elem) => elem.url !== url)
    } else {
      const response = await fetch(`${url}.js`)
      const product = await response.json()

      const firstAvailVariant = (product.variants || []).find(v => v.available) || (product.variants && product.variants[0]) || null

      wishlist.push({
        url,
        id: product.id,
        handle: product.handle,
        title: product.title,
        img_src: product.featured_image,
        img_alt: product.featured_image.alt,
        compare_at_price: product.compare_at_price,
        price: product.price,
        price_varies: product.price_varies,
        available: product.available !== false,
        variant_id: firstAvailVariant ? firstAvailVariant.id : null,
        variants_count: (product.variants || []).length,
        added_at: Date.now()
      })
    }

    this.wishlist = wishlist
    this.setCountBadges()
    this.setContent()
  }

  setCountBadges () {
    document.querySelectorAll('.wishlist-count-badge').forEach(elem => {
      elem.dataset.count = this.wishlist.length
      elem.textContent = this.wishlist.length
    })
  }

  setContent () {
    if (this.wishlist.length) {
      this.querySelector('.wishlist-empty').setAttribute('hidden', 'hidden')

      let productList = ''
      try {
      let imgWidth, imgHeight

      switch (this.dataset.imgOrientation) {
        case 'ratio-4x3':
          imgWidth = 600
          imgHeight = Math.round(600 / 4 * 3)
          break
        case 'ratio-16x9':
          imgWidth = 600
          imgHeight = Math.round(600 / 16 * 9)
          break
        case 'ratio-3x4':
          imgWidth = Math.round(600 / 4 * 3)
          imgHeight = 600
          break
        case 'ratio-9x16':
          imgWidth = Math.round(600 / 16 * 9)
          imgHeight = 600
          break
        default:
          imgWidth = 600
          imgHeight = 600
      }

      this.wishlist.forEach(product => {
        productList += `
          <li class="wishlist-product-item py-3">
            <div class="row mx-n3 align-items-center">
              <div class="col-6 px-3">
                <a href="${product.url}" tabindex="-1">
                  <img 
                    src="${product.img_src}"
                    class="img-fluid ${this.dataset.imgBorder}" 
                    alt="${product.img_alt}" 
                    width="${imgWidth}" 
                    height="${imgHeight}" 
                    style="object-fit: cover;"
                    loading="lazy">
                </a>
              </div>
              <div class="col-12 px-3 position-relative">
                <div class="me-10">
                  <h4 class="wishlist-product-item-title h6 mb-1 text-truncate">
                    <a href="${product.url}" class="link-dark text-decoration-none">
                      ${product.title}
                    </a>
                  </h4>
                  <p class="wishlist-product-item-price product-price mb-0">
                    <span ${product.compare_at_price > product.price ? '' : 'hidden'}>
                      <s class="product-card-price-compare">
                        <span class="visually-hidden">
                          ${window.theme.locales.product.regular_price}
                        </span>
                        ${window.Shopify.formatMoney(product.compare_at_price)}
                      </s>
                      <span class="product-card-price-final product-price-final-sale">
                        <span class="visually-hidden">
                          ${window.theme.locales.product.sale_price}
                        </span>
                        ${window.Shopify.formatMoney(product.price)}
                      </span>
                    </span>
                    <span class="product-card-price-final" ${product.compare_at_price > product.price ? 'hidden' : ''}>
                      ${window.Shopify.formatMoney(product.price)}
                    </span>
                  </p>
                  <p class="wishlist-product-item-added-at d-flex align-items-center fs-xs opacity-75 mb-0">
                    <svg xmlns="http://www.w3.org/2000/svg" class="me-2" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    ${window.theme.calcTimeAgo(product.added_at)}
                  </p>
                  <div class="wishlist-product-item-action mt-3">
                    <button 
                      class="btn btn-atc btn-wishlist-atc btn-sm w-100 ${this.dataset.quickViewBtnColor || 'btn-outline-primary'}" 
                      data-product-url="${product.url}"
                      data-variant-id="${product.variant_id || ''}"
                      type="button"
                      ${product.available === false ? 'disabled' : ''}>
                      ${product.available === false ? (window.theme.locales?.product?.sold_out || 'Sold Out') : (window.theme.locales?.product?.add_to_cart || 'Add to Cart')}
                    </button>
                  </div>
                </div>
                <button 
                  class="btn wishlist-product-item-btn-remove btn-icon position-absolute top-0 end-0 mt-n4 me-n1"
                  type="button"
                  aria-label="${window.theme.locales.accessibility.remove}"
                  data-product-url="${product.url}">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="svg-icon-remove " viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>
                  </svg>
                </button>
              </div>
            </div>
          </li>
        `
      })

      this.querySelector('.wishlist-product-list').innerHTML = productList
      this.querySelector('.wishlist-product-list').removeAttribute('hidden')

      document.querySelectorAll('.wishlist-product-item-btn-remove').forEach(removeBtn => {
        removeBtn.addEventListener('click', () => {
          this.setProduct(removeBtn.dataset.productUrl)

          document.querySelectorAll('wishlist-button').forEach(wishlistButton => {
            wishlistButton.adjustBtn()
          })
        })
      })

      // Add to Cart handler for Wishlist items
      this.querySelectorAll('.btn-wishlist-atc').forEach(atcBtn => {
        atcBtn.addEventListener('click', async (e) => {
          e.preventDefault()
          e.stopPropagation()

          if (atcBtn.disabled || atcBtn.classList.contains('is-loading')) return

          const originalText = atcBtn.getAttribute('data-original-text') || atcBtn.innerText.trim()
          if (!atcBtn.getAttribute('data-original-text')) {
            atcBtn.setAttribute('data-original-text', originalText)
          }

          atcBtn.innerText = 'Adding...'
          atcBtn.disabled = true
          atcBtn.classList.add('is-loading')

          let variantId = atcBtn.getAttribute('data-variant-id')

          // If variantId was not cached, fetch product JSON to get available variant
          if (!variantId) {
            try {
              const res = await fetch(`${atcBtn.dataset.productUrl}.js`)
              const prodData = await res.json()
              const availVariant = (prodData.variants || []).find(v => v.available) || (prodData.variants && prodData.variants[0])
              if (availVariant) {
                variantId = availVariant.id
                atcBtn.setAttribute('data-variant-id', variantId)
              }
            } catch (err) {
              console.error('[Wishlist ATC] Error fetching variant:', err)
            }
          }

          if (!variantId) {
            // If product has no variant or fetch failed, fallback to product page
            window.location.href = atcBtn.dataset.productUrl
            return
          }

          const cartContainer = document.querySelector('cart-container')

          const finishSuccess = (data) => {
            atcBtn.innerText = '✓ Added'
            atcBtn.classList.remove('is-loading')
            atcBtn.classList.add('is-success')

            window.dispatchEvent(new CustomEvent('kt.cart.added', { detail: data || {} }))
            document.dispatchEvent(new CustomEvent('cart:refresh'))

            const offcanvasCart = document.querySelector('#offcanvas-cart')
            if (offcanvasCart && window.bootstrap && typeof window.bootstrap.Offcanvas === 'function') {
              window.bootstrap.Offcanvas.getOrCreateInstance(offcanvasCart).show()
            }

            setTimeout(() => {
              atcBtn.innerText = originalText
              atcBtn.disabled = false
              atcBtn.classList.remove('is-success')
            }, 1200)
          }

          const finishError = (errorMsg) => {
            console.error('[Wishlist ATC] Add error:', errorMsg)
            atcBtn.innerText = 'Error'
            atcBtn.classList.remove('is-loading')
            atcBtn.classList.add('is-error')

            setTimeout(() => {
              atcBtn.innerText = originalText
              atcBtn.disabled = false
              atcBtn.classList.remove('is-error')
            }, 1500)
          }

          if (cartContainer && typeof cartContainer.add === 'function') {
            cartContainer.add({ items: [{ id: Number(variantId), quantity: 1 }] })
              .then(finishSuccess)
              .catch(err => finishError(err.message))
          } else {
            const formData = new FormData()
            formData.append('id', Number(variantId))
            formData.append('quantity', 1)
            formData.append('sections[]', 'offcanvas-cart')

            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: formData
            })
            .then(async (res) => {
              const data = await res.json()
              if (!res.ok) {
                throw new Error(data.description || data.message || 'Error adding to cart')
              }
              return data
            })
            .then(data => {
              if (data.sections && data.sections['offcanvas-cart']) {
                const parser = new DOMParser()
                const cartDoc = parser.parseFromString(data.sections['offcanvas-cart'], 'text/html')
                const currentCart = document.querySelector('#offcanvas-cart')
                const incomingCart = cartDoc.querySelector('#offcanvas-cart')
                if (currentCart && incomingCart) {
                  currentCart.innerHTML = incomingCart.innerHTML
                }
              }
              finishSuccess(data)
            })
            .catch(err => finishError(err.message))
          }
        })
      })
      } catch(e) {
         this.querySelector('.wishlist-product-list').innerHTML = `<li style="color:red; font-size: 14px; padding: 20px;">Debug Error: ${e.message}</li>`;
         this.querySelector('.wishlist-product-list').removeAttribute('hidden');
      }
    } else {
      this.querySelector('.wishlist-empty').removeAttribute('hidden')
      this.querySelector('.wishlist-product-list').innerHTML = ''
      this.querySelector('.wishlist-product-list').setAttribute('hidden', 'hidden')
    }
  }
}

customElements.define('wishlist-container', Wishlist)


class WishlistButton extends HTMLElement {
  constructor () {
    super()
  }

  connectedCallback() {
    setTimeout(() => {
      this.btn = this.querySelector('button')
      this.wishlistContainer = document.querySelector('wishlist-container')

      if (!this.btn || !this.wishlistContainer) return;
      this.adjustBtn()

      this.btn.addEventListener('click', async (event) => {
        event.preventDefault()

        await this.wishlistContainer.setProduct(this.dataset.productUrl)
        this.adjustBtn()
      })
    }, 0);
  }

  adjustBtn () {
    const isWishlisted = this.wishlistContainer.wishlist.some((elem) => elem.url === this.dataset.productUrl)

    if (isWishlisted) {
      this.btn.classList.add('active')
      this.btn.setAttribute('aria-label', window.theme.locales.wishlist.remove)
      this.btn.setAttribute('aria-pressed', 'true')
    } else {
      this.btn.classList.remove('active')
      this.btn.setAttribute('aria-label', window.theme.locales.wishlist.add)
      this.btn.setAttribute('aria-pressed', 'false')
    }
  }
}
customElements.define('wishlist-button', WishlistButton)
